import loadable from '@loadable/component';

const GraduateClass = loadable(() => import('./GraduateClass'));
const SelectClass = loadable(() => import('./SelectClass'));

export default [
  {
    path: '/graduate-class',
    component: GraduateClass,
    title: 'Graduate Class',
    breadcrumbs: [],
    exact: true,
  },
  {
    path: '/graduate-class/:id',
    component: SelectClass,
    title: 'Select Class',
    breadcrumbs: [],
    exact: true,
  },
];
